import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

//当前语言code

import jp from './lang/ja-jp';
import zhCN from './lang/zh-cn';
import zhTW from './lang/zh-tw';
var messages = {
  'ja-jp': jp,
  'zh-cn': zhCN,
  'zh-tw': zhTW
};
var i18n = new VueI18n({
  locale: 'ja-jp',
  // 设置地区
  messages: messages,
  // 设置地区信息
  silentTranslationWarn: true //关闭警告
});
export default i18n;